import { useForm } from "@mantine/form"
import React, { useState } from "react"
import { updateMailConf } from "../api"
import { notifications } from "@mantine/notifications"
import { Button, Checkbox, Group, Stack, Text, Title } from "@mantine/core"

interface FormValues {
  report_web_cv: boolean
  report_coming_cv: boolean
  is_report_inviter_name: boolean
  is_report_guest_name: boolean
  is_report_shop_name: boolean
  is_report_coming_mail: boolean
  is_report_coming_tel: boolean
  is_report_coming_address: boolean
  is_report_coming_other: boolean
  notify_guest_shop: boolean
  notify_inviter_shop: boolean
}

interface Props {
  clientId: number
  initialValues: FormValues
  invyServiceUse: string
  onSaved?: () => void
}

const MailConfForm: React.FC<Props> = ({ clientId, initialValues, invyServiceUse: rawInvyServiceUse, onSaved }) => {
  const invyServiceUse = String(rawInvyServiceUse)
  const [submitting, setSubmitting] = useState(false)

  const form = useForm<FormValues>({ initialValues })

  const handleSubmit = async (values: FormValues) => {
    setSubmitting(true)

    try {
      await updateMailConf(clientId, values)
      notifications.show({ message: '保存しました', color: 'teal' })
      onSaved?.()
    } catch (e) {
      notifications.show({ message: '保存に失敗しました', color: 'red' })
    } finally {
      setSubmitting(false)
    }
  }

  const showWebCv = invyServiceUse === '0' || invyServiceUse === '2'
  const showComingCv = invyServiceUse === '1' || invyServiceUse === '2'
  const showDisplayInfo = invyServiceUse === '0' || invyServiceUse === '1' || invyServiceUse === '2'
  const showComingFields = invyServiceUse === '1' || invyServiceUse === '2'

  return (
    <form onSubmit={form.onSubmit(handleSubmit)}>
      <Stack gap={32} bg="#00000008" p={16} bdrs={8}>
        {/* CV通知メール設定 */}
        <Stack gap={16}>
          <Title order={2} size={18} fw={600}>CV通知メール設定</Title>
          <Text fz={14} c="#000000CC">
            コンバージョンが発生した際に、以下に登録したメールアドレスへ都度通知を行います。
          </Text>
          <Stack gap={12}>
            {showWebCv && (
              <Checkbox
                label={
                  <>
                    <Text fz={14} fw={500}>WebCV</Text>
                    <Text fz={12} c="#00000099">貴社の完了ページにinvyのタグ設置が必要です。</Text>
                  </>
                }
                {...form.getInputProps('report_web_cv', { type: 'checkbox' })}
              />
            )}
            {showComingCv && (
              <Checkbox
                label={
                  <>
                    <Text fz={14} fw={500}>来店CV</Text>
                    <Text fz={12} c="#00000099">来店計測機能をご使用の場合に計測可能です。</Text>
                  </>
                }
                {...form.getInputProps('report_coming_cv', { type: 'checkbox' })}
              />
            )}
          </Stack>
          {showDisplayInfo && (
            <Stack gap={8}>
              <Title order={3} size={16} fw={600}>表示情報</Title>
              <Checkbox label="紹介者の名前" {...form.getInputProps('is_report_inviter_name', { type: 'checkbox' })} />
              <Checkbox label="紹介者の店舗名" {...form.getInputProps('is_report_shop_name', { type: 'checkbox' })} />
              <Checkbox label="ゲストの名前" {...form.getInputProps('is_report_guest_name', { type: 'checkbox' })} />
              {showComingFields && (
                <>
                  <Checkbox label="ゲストのメールアドレス（来店）" {...form.getInputProps('is_report_coming_mail', { type: 'checkbox' })} />
                  <Checkbox label="ゲストの電話番号（来店）" {...form.getInputProps('is_report_coming_tel', { type: 'checkbox' })} />
                  <Checkbox label="ゲストの住所（来店）" {...form.getInputProps('is_report_coming_address', { type: 'checkbox' })} />
                  <Checkbox label="ゲストの会員番号（来店）" {...form.getInputProps('is_report_coming_other', { type: 'checkbox' })} />
                </>
              )}
            </Stack>
          )}
        </Stack>

        {/* 店舗メール通知設定 */}
        <Stack gap={16} mt={16}>
          <Title order={2} size={18} fw={600}>店舗メール通知設定</Title>
          <Text fz={14} c="#000000CC">
            来店CV発生時に店舗の通知用メールアドレスに通知メールを送信します。
          </Text>
          <Stack gap={8}>
            <Checkbox label="紹介者側の店舗に送る" {...form.getInputProps('notify_inviter_shop', { type: 'checkbox' })} />
            <Checkbox label="ゲスト側の店舗に送る" {...form.getInputProps('notify_guest_shop', { type: 'checkbox' })} />
          </Stack>
        </Stack>

        <Group justify="end">
          <Button
            type="submit"
            variant="filled"
            radius="xl"
            fz={13}
            fw={600}
            w={120}
            disabled={submitting}
          >
            {submitting ? '処理中' : '保存'}
          </Button>
        </Group>
      </Stack>
    </form>
  )
}

export default MailConfForm
